export const getIsProd = () => {
    const domain = window.location.origin;
    return !(domain.includes('dev') ||
        domain.includes('local') ||
        domain.includes('stg'));
};
//# sourceMappingURL=get-is-prod.js.map